import type { DictionaryValuesResponse, LanguagesResponse } from './httpResponses.ts'
import httpClient from '@/services/http/httpClient.ts'

class DictionariesHttpService {
  public getCategoryDictionary() {
    return httpClient.get<DictionaryValuesResponse>(
      `/api/v1/admin/dictionaries/Категории`, // todo bad code, hardcoded value
    )
  }
  public getSupportedLanguages() {
    return httpClient.get<LanguagesResponse>('/api/v1/admin/supported-languages')
  }
  public getDictionaries() {
    return httpClient.get<{ dictionaries: string[] }>('/api/v1/admin/dictionaries')
  }
  public getDictionaryValues(dictionaryType: string) {
    return httpClient.get<DictionaryValuesResponse>(`/api/v1/admin/dictionaries/${dictionaryType}`)
  }
}

export default new DictionariesHttpService()
